<template>
  <div id="app">
    <topbar></topbar>
    <mainnav  v-if="$root.showNav"></mainnav>
    <vue-page-transition name="fade" style="width: 100%;">
      <router-view/>
    </vue-page-transition>
    <locale-changer></locale-changer>
  </div>
</template>

<script>

import TopBar from '@/components/TopBar.vue';
import MainNav from "@/components/MainNavigation.vue";
import LocaleChanger from '@/components/LocaleChanger.vue';

export default {
    components: {
        'topbar': TopBar,
        'mainnav': MainNav,
        'locale-changer': LocaleChanger,
    }
}

</script>

<style lang="scss">
* {
 margin: 0;
 padding: 0;
}

@font-face {
  font-family: "Demi";
  src:url('assets/fonts/DaimlerCSPro-Demi.otf') format("opentype");
}

@font-face {
  font-family: "Regular";
  src:url('assets/fonts/DaimlerCSPro-Regular.otf') format("opentype");
}

@font-face {
  font-family: "Light";
  src:url('assets/fonts/DaimlerCSPro-Light.otf') format("opentype");
}

@font-face {
  font-family: "CorpBold";
  src:url('assets/fonts/CorporateS-Bold.otf') format("opentype");
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
  background-image: url('assets/background.svg');
  background-repeat: no-repeat;
  background-position-x: 105%;
  background-position-y: 45px;
  background-size: contain;
}

.content-full-h {
  height: calc(100vh - 137px);
}

.remove-top-margin {
  margin-top: -37px;
}

[v-cloak] {display: none}

video {
  width: 100%;
}

a {
  text-decoration: none;
}

@media only screen and (max-device-width : 1366px) {
  video {
    height: 100vh;
    margin-top: -100px;
    object-fit: cover;
  }
}

</style>
